// extracted by mini-css-extract-plugin
export var buttons = "style-module--buttons--552d4";
export var preview = "style-module--preview--25058";
export var submitStatus = "style-module--submitStatus--c47f9";
export var subsection = "style-module--subsection--4a84a";